import { RegisterForm } from "@/components/features";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Form,
  ModeToggle,
  Typography,
} from "@/components/ui";
import { LawWorksLogo } from "@/components/ui/LawWorksLogo/LawWorksLogo";
import { redirectIfAuthenticated } from "@/lib/utils/auth";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { z } from "zod";

const registerFormSchema = z.object({
  firmName: z.string().min(1, { message: "Firm name is required" }).max(50),
  email: z.string().min(1, { message: "Email is required" }).email().max(50),
  firstName: z.string().min(1, { message: "First name is required" }).max(50),
  lastName: z.string().min(1, { message: "Last name is required" }).max(50),
  phoneNumber: z
    .string()
    .min(1, { message: "Phone number is required" })
    .max(25),
});

export const Route = createFileRoute("/register")({
  component: RouteComponent,
  beforeLoad: ({ context, location }) => {
    redirectIfAuthenticated({ session: context.session, location });
  },
});

function RouteComponent() {
  const form = useForm<z.infer<typeof registerFormSchema>>({
    resolver: zodResolver(registerFormSchema),
    values: {
      firmName: "",
      email: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
    },
    mode: "onSubmit",
  });

  const onSubmit = async () => {};

  return (
    <div className="flex h-[99vh] w-[99vw] grow content-center justify-center overflow-hidden">
      <div className="sm:px-auto my-auto w-full max-w-[500px] px-4">
        <Card className="p-6">
          <CardHeader>
            <LawWorksLogo className="justify-self-center" />
          </CardHeader>
          <CardContent>
            <Form {...form}>
              <RegisterForm onSubmit={onSubmit} />
            </Form>
          </CardContent>
          <div className="float-right pr-6">
            <ModeToggle />
          </div>
          <CardFooter className="flex flex-col items-start">
            <span className="mt-2 flex flex-wrap text-sm font-light">
              <Typography className="pr-1">Already have an account?</Typography>
              <Link to="/login">
                <Typography variant="link">Sign in</Typography>
              </Link>
            </span>
          </CardFooter>
        </Card>
      </div>
      <div></div>
    </div>
  );
}
